import React from 'react'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import Typography from '@material-ui/core/Typography'
import notificacionesData from '../../../notificaciones.json'

interface Notificacion {
  name: string
  fecha: string
  html: string
}

const notificaciones: Notificacion[] = notificacionesData as Notificacion[]

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerPaper: {
      width: 360,
      maxWidth: '100vw',
      [theme.breakpoints.up('sm')]: {
        width: 400,
      },
    },
    drawerHeader: {
      padding: theme.spacing(2, 2, 1.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    notificacionItem: {
      padding: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    notificacionHtml: {
      '& p': { margin: '0 0 8px', fontSize: '0.875rem' },
      '& p:last-child': { marginBottom: 0 },
      '& img': { maxWidth: '100%', height: 'auto', borderRadius: 8, marginTop: 12 },
    },
  }),
)

interface NotificationsDrawerProps {
  open: boolean
  onClose: () => void
}

export default function NotificationsDrawer({ open, onClose }: NotificationsDrawerProps) {
  const classes = useStyles()

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <div className={classes.drawerHeader}>
        <Typography variant="h6">Notificaciones</Typography>
      </div>
      <div role="presentation">
        {notificaciones.length === 0 ? (
          <Typography variant="body2" color="textSecondary" style={{ padding: 24 }}>
            No hay notificaciones.
          </Typography>
        ) : (
          notificaciones.map((notif, index) => (
            <div key={index} className={classes.notificacionItem}>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                {notif.name}
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 8 }}>
                {notif.fecha}
              </Typography>
              <div
                className={classes.notificacionHtml}
                dangerouslySetInnerHTML={{ __html: notif.html }}
              />
            </div>
          ))
        )}
      </div>
    </Drawer>
  )
}

export { notificaciones }
